import React from 'react';
import { FormState, useForm } from 'react-hook-form';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';
import { CandidateEmailInput } from '../CandidateEmailInput';
import { CandidateNameInput } from '../CandidateNameInput';
import { CandidatePhoneInput } from '../CandidatePhoneInput';
import { CandidateLinkedinInput } from '../CandidateLinkedinInput';
import { CandidateService } from '../../../../services/applicant_tracking/CandidateService';
import { handleFormErrors } from '../../../../services/ApiService/handler';
import { Candidate } from '../../../../entities/applicant_tracking/Candidate';
import { FormErrorMessage } from '../../../../components/FormErrorMessage';
import { LocationInput } from '../LocationInput';

interface PropTypes {
  onSuccessfulSubmit: (candidate: Candidate, e: React.SyntheticEvent) => void;
  headerFactory: (formState: FormState<CandidateDto>) => React.ReactNode;
  candidateDto?: CandidateDto;
  isEditing?: boolean;
}

export default function CandidateForm(props: PropTypes) {
  const { handleSubmit, control, register, formState, trigger, setError } =
    useForm<CandidateDto>({
      defaultValues: props.candidateDto,
      mode: 'onChange',
    });

  async function onSubmit(data: CandidateDto, e: React.SyntheticEvent) {
    try {
      const candidate = await CandidateService.upsertCandidate(
        data,
        !!props.isEditing,
      );
      props.onSuccessfulSubmit(candidate, e);
    } catch (e: unknown) {
      handleFormErrors(e, setError);
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormErrorMessage error={formState.errors} />
      {props.headerFactory(formState)}
      <CandidateNameInput errors={formState.errors} formRegister={register} />
      <CandidatePhoneInput
        control={control}
        formRegister={register}
        errors={formState.errors}
      />
      <CandidateEmailInput
        errors={formState.errors}
        formRegister={register}
        trigger={trigger}
      />
      <CandidateLinkedinInput formRegister={register} />
      <LocationInput control={control} location={props.candidateDto.location} />
    </form>
  );
}
